
















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DropDownButton extends Vue {
  @Prop() text!: string
}
